<template>
  <vue-drr
    :parent="true"
    :rotatable="false"
    :w="w"
    :h="h"
    :x="x"
    :y="y"
    class="widget-container"
    ref="widget"
    @dragstop="dragStop"
    @resizestop="resizeStop"
    :style="{
      zIndex: zIndex
    }"
  >
    <div
      class="ticky-wrap"
      :id="`widget${id}`"
      @click="setActiveWidget"
      :style="{
        backgroundColor: backgroundColor
      }"
    >
      <div
        class="ticky"
        :style="{
          animationDuration: animationDuration + 's'
        }"
      >
        <div
          class="ticky-item ml-3 mr-3"
          v-for="feed in feeds"
          :key="feed"
          :style="{
            color: color,
            fontSize: fontSize + 'px',
            lineHeight: h + 'px'
          }"
        >
          {{ feed }}
        </div>
      </div>
    </div>
  </vue-drr>
</template>

<script>
import VueDrr from 'vue-drr';
import WidgetMixin from './WidgetMixin';
import { mapWidgets } from './WidgetUtils';

export default {
  components: {
    'vue-drr': VueDrr,
  },
  mixins: [WidgetMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: '',
          key: 'name',
        },
        {
          path: '',
          key: 'icon',
        },
        {
          path: '',
          key: 'component',
        },
        {
          path: 'dataTicker',
          key: 'feeds',
        },
        {
          path: 'style',
          key: 'backgroundColor',
        },
        {
          path: 'style',
          key: 'color',
        },
        {
          path: 'style',
          key: 'animationDuration',
        },
        {
          path: 'style',
          key: 'fontSize',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
      ],
    ),
  },
};
</script>

<style lang='css'>
@-webkit-keyframes tickytack {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-150%, 0, 0);
    transform: translate3d(-150%, 0, 0);
  }
}

@keyframes tickytack {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-150%, 0, 0);
    transform: translate3d(-150%, 0, 0);
  }
}

.ticky-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: content-box;
}

.ticky {
  display: inline-block;
  width: 100%;
  height:100%;
  white-space: nowrap;
  padding-left: 100%;
  box-sizing: content-box;
  text-align: end;
  margin-left: 50%;

  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;

  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;
  animation-timing-function: linear;

  -webkit-animation-name: tickytack;
  -moz-animation-name: tickytack;
  animation-name: tickytack;
}

.ticky-item {
  display: inline-block;
  height: 100%;
}
</style>
